import React from "react";
import DatePicker from "../shared/form/DatePicker";

export const dateOfBirth = "dateOfBirth";

function MemberDobInput({ onChange, date, label, ariaLabel, mfa }) {
  return (
    <div className="form-group">
      <DatePicker
        id="memberDob"
        label={label}
        type="dateSelect"
        ageOffset="16"
        numYears="120"
        ariaLabel={ariaLabel}
        date={date}
        updateDate={(dateUpdated) => {
          onChange(dateUpdated, dateOfBirth);
        }}
        mfa={mfa}
      />
    </div>
  );
}

export default MemberDobInput;
